import createStore from "astrid-helpers/src/createStore";
import { defaultOptions } from "astrid-helpers/src/findSilences";

export const [getGateOptions, setGateOptions, useGateOptions] = createStore(defaultOptions);
